<template>
    <div class="survey-slider-container">
        <range-slider class="slider"
                      min="1"
                      max="100"
                      step="1"
                      v-model="model" v-on:change="onModelChange"></range-slider>
        <div class="slider-placeholder clearfix">
            <span class="slider-placeholder__first">{{field.placeholder.split(',')[0]}}</span>
            <span class="slider-placeholder__second">{{field.placeholder.split(',')[1]}}</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SurveySlider',
  props: ['field'],
  data() {
    return {
      model: this.field.value,
    };
  },
  methods: {
    onModelChange() {
      this.$emit('modelChange', {
        newVal: this.model,
        oldVal: this.field.value,
        fieldId: this.field.id,
      });
      this.field.value = this.model;
      this.$emit('nodeChange', this.field);
    },
  },
};
</script>

<style src="./SurveySlider.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveySlider/SurveySlider.vue